function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import React from 'react';
import PropTypes from 'prop-types';
import SelectedFilter from './selected-filter';
import FilterSelect from './filter-select';
import FilterCheck from './filter-check';
import FilterToggle from './filter-toggle';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Filter = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Filter, _React$PureComponent);
  var _super = _createSuper(Filter);
  function Filter(props) {
    var _this;
    _classCallCheck(this, Filter);
    _this = _super.call(this, props);
    _this.renderActiveFilters = _this.renderActiveFilters.bind(_assertThisInitialized(_this));
    _this.state = {
      visibleBlocks: {
        sectors: false,
        usages: false,
        materials: false,
        types: false
      },
      visibleSectorFilters: []
    };
    return _this;
  }
  _createClass(Filter, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this$props = this.props,
        sectors = _this$props.sectors,
        currentSector = _this$props.currentSector;
      var sectorArray = [];
      if (currentSector) {
        sectors.forEach(function (sector) {
          if (sector.ID !== currentSector.ID) {
            sectorArray.push(sector);
          }
        });
        this.setState({
          visibleSectorFilters: sectorArray
        });
      }
    }
  }, {
    key: "toggleFilterBlock",
    value: function toggleFilterBlock(block) {
      this.setState({
        visibleBlocks: _objectSpread(_objectSpread({}, this.state.visibleBlocks), {}, _defineProperty({}, block, !this.state.visibleBlocks[block]))
      });
    }
  }, {
    key: "renderActiveFilters",
    value: function renderActiveFilters() {
      var _this2 = this;
      var selectedFilters = [];
      if (this.props.pageType !== 'resources' && this.props.filters.usages.length) {
        this.props.filters.usages.forEach(function (filter) {
          _this2.props.usages.filter(function (usage) {
            if (usage.ID === filter) {
              var object = usage;
              object.Type = 'usage';
              selectedFilters.push(object);
            }
            return true;
          });
        });
      }
      if (this.props.pageType === 'resources' && this.props.filters.sectors.length) {
        this.props.filters.sectors.forEach(function (filter) {
          _this2.props.sectors.filter(function (sector) {
            if (sector.ID === filter) {
              var object = sector;
              object.Type = 'sector';
              selectedFilters.push(object);
            }
            return true;
          });
        });
      }
      if (this.props.pageType === 'resources' && this.props.filters.types.length) {
        this.props.filters.types.forEach(function (filter) {
          _this2.props.types.filter(function (type) {
            if (type.ID === filter) {
              var object = type;
              object.Type = 'type';
              selectedFilters.push(object);
            }
            return true;
          });
        });
      }
      if (this.props.pageType === 'resources' && this.props.filters.product > 0) {
        this.props.products.filter(function (type) {
          if (type.ID === _this2.props.filters.product) {
            var object = type;
            object.Type = 'product';
            selectedFilters.push(object);
          }
          return true;
        });
      }
      if (this.props.filters.materials.length) {
        this.props.filters.materials.forEach(function (filter) {
          _this2.props.materials.filter(function (material) {
            if (material.ID === filter) {
              var object = material;
              object.Type = 'material';
              selectedFilters.push(object);
            }
            return true;
          });
        });
      }
      return selectedFilters.map(function (filter) {
        return /*#__PURE__*/_jsx(SelectedFilter, {
          id: filter.ID,
          label: filter.Title,
          type: filter.Type,
          removeFilter: _this2.props.removeFilter
        }, "".concat(filter.Title).concat(filter.ID));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var toggleSVG = /*#__PURE__*/_jsx("svg", {
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/_jsxs("g", {
          stroke: "#FDCA35",
          strokeWidth: "2",
          fill: "none",
          fillRule: "evenodd",
          children: [/*#__PURE__*/_jsx("path", {
            d: "M14 7H0"
          }), /*#__PURE__*/_jsx("path", {
            d: "M7 0v14"
          })]
        })
      });
      var sectorList = this.props.sectors;
      var contextualUsages = [];
      if (this.props.currentSector.ID) {
        sectorList = this.state.visibleSectorFilters;
        this.props.usages.forEach(function (usage) {
          if (parseInt(usage.Sector, 10) === _this3.props.currentSector.ID) {
            contextualUsages = [].concat(_toConsumableArray(contextualUsages), [usage]);
          }
        });
      } else {
        contextualUsages = this.props.usages;
      }
      return /*#__PURE__*/_jsxs("div", {
        className: "c-filter",
        children: [/*#__PURE__*/_jsx(FilterToggle, {
          handleToggleFilters: this.props.handleToggleFilters,
          filters: this.props.filters,
          filtersOpen: this.props.filtersOpen
        }), /*#__PURE__*/_jsxs(React.Fragment, {
          children: [/*#__PURE__*/_jsxs("h3", {
            className: "c-filter__title",
            children: ["Filter by", this.props.filters.sectors.length || this.props.filters.materials.length || this.props.filters.types.length || this.props.filters.usages.length || this.props.filters.product > 0 ? /*#__PURE__*/_jsx("button", {
              className: "c-filter__clear",
              onClick: this.props.clearFilters,
              children: "Clear all"
            }) : null]
          }), this.props.filters.sectors.length || this.props.filters.materials.length || this.props.filters.types.length || this.props.filters.usages.length || this.props.filters.product > 0 ? /*#__PURE__*/_jsx("div", {
            className: "c-filter__selected",
            children: this.renderActiveFilters()
          }) : null]
        }), this.props.products.length ? /*#__PURE__*/_jsx(React.Fragment, {
          children: /*#__PURE__*/_jsxs("div", {
            className: "c-filter__block",
            children: [/*#__PURE__*/_jsx("h2", {
              className: "c-filter__heading",
              children: "Filter by product"
            }), /*#__PURE__*/_jsx(FilterSelect, {
              products: this.props.products,
              onSelect: this.props.addFilter,
              filters: this.props.filters
            })]
          })
        }) : null, this.props.usages.length ? /*#__PURE__*/_jsx(React.Fragment, {
          children: /*#__PURE__*/_jsxs("div", {
            className: "c-filter__block",
            children: [/*#__PURE__*/_jsx("button", {
              className: "c-filter__toggle".concat(this.state.visibleBlocks.usages ? ' c-filter__toggle--open' : ''),
              onClick: function onClick() {
                return _this3.toggleFilterBlock('usages');
              },
              children: /*#__PURE__*/_jsxs("h2", {
                className: "c-filter__heading",
                children: [toggleSVG, "Usages"]
              })
            }), this.state.visibleBlocks.usages && contextualUsages.map(function (usage) {
              return /*#__PURE__*/_jsx(FilterCheck, {
                id: usage.ID,
                label: usage.Title,
                type: "usage",
                onSelect: _this3.props.addFilter,
                selectedFilters: _this3.props.filters.usages
              }, "Usage".concat(usage.ID));
            })]
          })
        }) : null, this.props.materials.length ? /*#__PURE__*/_jsx(React.Fragment, {
          children: /*#__PURE__*/_jsxs("div", {
            className: "c-filter__block",
            children: [/*#__PURE__*/_jsx("button", {
              className: "c-filter__toggle".concat(this.state.visibleBlocks.materials ? ' c-filter__toggle--open' : ''),
              onClick: function onClick() {
                return _this3.toggleFilterBlock('materials');
              },
              children: /*#__PURE__*/_jsxs("h2", {
                className: "c-filter__heading",
                children: [toggleSVG, "Materials"]
              })
            }), this.state.visibleBlocks.materials && this.props.materials.map(function (material) {
              return /*#__PURE__*/_jsx(FilterCheck, {
                id: material.ID,
                label: material.Title,
                type: "material",
                onSelect: _this3.props.addFilter,
                selectedFilters: _this3.props.filters.materials
              }, "Material".concat(material.ID));
            })]
          })
        }) : null, this.props.types.length ? /*#__PURE__*/_jsx(React.Fragment, {
          children: /*#__PURE__*/_jsxs("div", {
            className: "c-filter__block",
            children: [/*#__PURE__*/_jsx("button", {
              className: "c-filter__toggle".concat(this.state.visibleBlocks.types ? ' c-filter__toggle--open' : ''),
              onClick: function onClick() {
                return _this3.toggleFilterBlock('types');
              },
              children: /*#__PURE__*/_jsxs("h2", {
                className: "c-filter__heading",
                children: [toggleSVG, "Resource type"]
              })
            }), this.state.visibleBlocks.types && this.props.types.map(function (type) {
              return /*#__PURE__*/_jsx(FilterCheck, {
                id: type.ID,
                label: type.Title,
                count: type.Count,
                type: "type",
                onSelect: _this3.props.addFilter,
                selectedFilters: _this3.props.filters.types
              }, "ResourceType".concat(type.ID));
            })]
          })
        }) : null, sectorList.length && this.props.pageType === 'resources' ? /*#__PURE__*/_jsx(React.Fragment, {
          children: /*#__PURE__*/_jsxs("div", {
            className: "c-filter__block",
            children: [/*#__PURE__*/_jsx("button", {
              className: "c-filter__toggle".concat(this.state.visibleBlocks.sectors ? ' c-filter__toggle--open' : ''),
              onClick: function onClick() {
                return _this3.toggleFilterBlock('sectors');
              },
              children: /*#__PURE__*/_jsxs("h2", {
                className: "c-filter__heading",
                children: [toggleSVG, "Sectors"]
              })
            }), this.state.visibleBlocks.sectors && sectorList.map(function (sector) {
              return /*#__PURE__*/_jsx(FilterCheck, {
                id: sector.ID,
                label: sector.Title,
                type: "sector",
                count: sector.Count,
                onSelect: _this3.props.addFilter,
                selectedFilters: _this3.props.filters.sectors
              }, "ResourceType".concat(sector.ID));
            })]
          })
        }) : null, sectorList.length && this.props.pageType === 'products' ? /*#__PURE__*/_jsx(React.Fragment, {
          children: /*#__PURE__*/_jsxs("div", {
            className: "c-filter__block",
            children: [/*#__PURE__*/_jsx("button", {
              className: "c-filter__toggle".concat(this.state.visibleBlocks.sectors ? ' c-filter__toggle--open' : ''),
              onClick: function onClick() {
                return _this3.toggleFilterBlock('sectors');
              },
              children: /*#__PURE__*/_jsxs("h2", {
                className: "c-filter__heading",
                children: [toggleSVG, "Sectors"]
              })
            }), this.state.visibleBlocks.sectors && sectorList.map(function (sector) {
              return /*#__PURE__*/_jsx("div", {
                className: "c-filter__link",
                children: /*#__PURE__*/_jsx("a", {
                  href: sector.Link,
                  children: sector.Title
                })
              }, "Sector".concat(sector.ID));
            })]
          })
        }) : null, /*#__PURE__*/_jsx(FilterToggle, {
          handleToggleFilters: this.props.handleToggleFilters,
          filters: this.props.filters,
          filtersOpen: this.props.filtersOpen
        })]
      });
    }
  }]);
  return Filter;
}(React.PureComponent);
Filter.defaultProps = {
  products: [],
  types: [],
  usages: [],
  materials: [],
  pageType: 'products',
  currentSector: {
    ID: null
  }
};
Filter.propTypes = {
  types: PropTypes.arrayOf(PropTypes.object),
  products: PropTypes.arrayOf(PropTypes.object),
  usages: PropTypes.arrayOf(PropTypes.object),
  materials: PropTypes.arrayOf(PropTypes.object),
  addFilter: PropTypes.func.isRequired,
  removeFilter: PropTypes.func.isRequired,
  clearFilters: PropTypes.func.isRequired,
  handleToggleFilters: PropTypes.func.isRequired,
  filters: PropTypes.objectOf(PropTypes.any).isRequired,
  filtersOpen: PropTypes.bool.isRequired,
  sectors: PropTypes.arrayOf(PropTypes.object).isRequired,
  pageType: PropTypes.string,
  currentSector: PropTypes.objectOf(PropTypes.any)
};
export default Filter;